import { render, staticRenderFns } from "./SelectiveBrokerCompareView.vue?vue&type=template&id=08d78a24&"
import script from "./SelectiveBrokerCompareView.vue?vue&type=script&lang=js&"
export * from "./SelectiveBrokerCompareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports